Bingo.AjaxForward = {};

Bingo.AjaxForward.init = () => {
    $('.js-landingPage__forward').each(function () {
        $.nette.ajax({
            url: $(this).data('forward-to-url'),
            off: ['unique'],
        });
    });
};
